import { useEffect, useState } from "react";

const getViewportWidth = () =>
  typeof window === "undefined" ? 1280 : window.innerWidth;

export default function useViewport() {
  const [width, setWidth] = useState(getViewportWidth);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return {
    width,
    isMobile: width < 768,
    isTablet: width >= 768 && width < 1100,
    isCompact: width < 1100,
  };
}
